<template>
  <div class="list-container">
    <Empty v-if="isEmpty(members)"></Empty>
    <ul class="list-container-list" v-else>
      <li v-for="(member, index) in members.slice((currentPage-1)*pageSize,currentPage*pageSize)" :key="index" :class="className">
        <img :src="member.logo" alt="" />
      </li>
    </ul>
    <div class="list-container-page" v-if="members.length > pageSize">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Empty from '@/components/empty.vue'
// import { members } from '@/utils/helper';
import { isEmpty, get } from 'lodash';
import { union } from '@/api/api'
export default {
  name: 'member-list',
  components: {
    Empty
  },
  props: {
    className: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      members: [],
      currentPage: 1,
      pageSize: 15,
      total: 0
    };
  },
  created () {
    this.getMemberLogo()
  },
  methods: {
    isEmpty,
    handleCurrentChange (val) {
      this.currentPage = val;
    },
    async getMemberLogo () {
      let { data } = await union.getMemberLogo()
      this.members = get(data, 'data.data')
      this.total = get(data, 'data.total');
    }
  }
};
</script>

<style scoped lang="scss">
.list-container {
  overflow: hidden;
  &-list {
    height: 360px;
    overflow: hidden;
    .home-member {
      border: 1px solid rgba(230,230,230,1);
    }
  }
  &-page {
    text-align: right;
    margin:-30px 0 16px;
  }
}
ul {
  margin: 0 -100px 0 0;
  li {
    width: 224px;
    height: 80px;
    float: left;
    padding: 16px 32px;
    margin: 0 18px 40px 0;
    background: #fff;
    border-radius: 3px;
    img{
      width: 160px;
      height: 48px;
    }
  }
}
::v-deep {
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    background: #fff;
    border: 1px solid rgba(204,204,204,1);
    border-radius: 3px;
  }
}
</style>
